import { useContext } from 'react';
import { ShopCartContext } from '../context';

export function useShopCart() {
  const { shopCart, setShopCart, refreshShopCart } =
    useContext(ShopCartContext);
  return [shopCart, setShopCart, refreshShopCart] as const;
}
export default useShopCart;
